import { render, staticRenderFns } from "./AdInfo.vue?vue&type=template&id=29d228ed&"
import script from "./AdInfo.vue?vue&type=script&lang=js&"
export * from "./AdInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports